import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { ToolValidationConflictTool } from '@app/tool/model/tool-validation-conflict-tool.model';

@Component({
    selector: 'app-tool-property-validation-info-modal',
    templateUrl: './tool-property-validation-info-modal.component.html',
    styleUrls: ['./tool-property-validation-info-modal.component.scss']
})
export class ToolPropertyValidationInfoModalComponent {
    @ViewChild(ModalComponent, { static: true }) modal: ModalComponent;

    @Input() title: string;
    @Input() message: string;
    @Input() tools: ToolValidationConflictTool[] = [];

    @Output() confirm = new EventEmitter<void>();

    open() {
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    onConfirm() {
        this.confirm.emit();
        this.close();
    }
}
